export const responseDataPermissionUsingRole: any = {
    admin: {
        user_locations: {
            stateCodes: null,
            districts: null,
        },
        user_role: [
            {
                role_slug: "admin",
            },
        ],
        user_department: [],
        user_type: [],
        user_number: [],
        user_role_permission: [
            // {
            //     uuid: "dashboard-001",
            //     parent_id: "0",
            //     name: "Dashboard",
            //     slug: "dashboard",
            //     module_url: "/admin/dashboard",
            //     icon: "Dashboard",
            //     module_order: "1",
            //     is_navigation: 1,
            // },
            {
                uuid: "companies-001",
                parent_id: "0",
                name: "Companies",
                slug: "companies",
                module_url: "/admin/companies",
                icon: "Business",
                module_order: "2",
                is_navigation: 1,
            },
            {
                uuid: "product-001",
                parent_id: "0",
                name: "Products",
                slug: "products",
                module_url: "/admin/products",
                icon: "Inventory",
                module_order: "3",
                is_navigation: 1,
            },
            {
                uuid: "qr-static-001",
                parent_id: "0",
                name: "Static QR",
                slug: "static-qr",
                module_url: "/admin/static-qr",
                icon: "QrCode",
                module_order: "4",
                is_navigation: 1,
            },
            {
                uuid: "qr-dynamic-001",
                parent_id: "0",
                name: "Dynamic QR",
                slug: "dynamic-qr",
                module_url: "/admin/dynamic-qr",
                icon: "QrCodeScanner",
                module_order: "5",
                is_navigation: 1,
            },
            // {
            //     uuid: "users-001",
            //     parent_id: "0",
            //     name: "Users",
            //     slug: "users",
            //     module_url: "/admin/users",
            //     icon: "People",
            //     module_order: "6",
            //     is_navigation: 1,
            // }
        ],
    },
    company_admin: {
        user_locations: {
            stateCodes: null,
            districts: null,
        },
        user_role: [
            {
                role_slug: "company_admin",
            },
        ],
        user_department: [],
        user_type: [],
        user_number: [],
        user_role_permission: [
            {
                uuid: "product-001",
                parent_id: "0",
                name: "Products",
                slug: "products",
                module_url: "/admin/products",
                icon: "Inventory",
                module_order: "3",
                is_navigation: 1,
            },
            {
                uuid: "qr-static-001",
                parent_id: "0",
                name: "Static QR",
                slug: "static-qr",
                module_url: "/admin/static-qr",
                icon: "QrCode",
                module_order: "4",
                is_navigation: 1,
            },
            {
                uuid: "qr-dynamic-001",
                parent_id: "0",
                name: "Dynamic QR",
                slug: "dynamic-qr",
                module_url: "/admin/dynamic-qr",
                icon: "QrCodeScanner",
                module_order: "5",
                is_navigation: 1,
            },
        ],
    },
};
